import React, { useState, useEffect } from "react";
import NavHeader from "../components/navigation/NavHeader";
import Footer from "../components/navigation/Footer";
import GoUpDown from "../components/navigation/GoUpDown";
import CommunityAccordion from "../components/community/CommunityAccordion";
import CommunityAccordionSkeleton from "../components/skeletons/CommunityAccordionSkeleton";
import AsideLeft from "../components/aside/AsideLeft";
import AsideRight from "../components/aside/AsideRight";
import JobListingCommunityAccordion from "../components/joblisting/JobListingCommunityAccordion";
import CommunityLayout from "../components/layouts/CommunityLayout";
import CommunityRequestIcon from "../components/icons/Community";
import { usePageTitle } from '../hooks/usePageTitle';
import { useParams } from "react-router-dom";
import { getCommunityToDisplay } from "../core/communities";

const Community = () => {

    usePageTitle('Community - Wefayo');
    const [isLoading, setIsLoading] = useState(true);
    const [displayedCommunities, setDisplayedCommunities] = useState([]);
    const [loggedInUser, setLoggedInUser] = useState(null);
    const [ currentCommunity, setCurrentCommunity ] = useState(null);
    const { comid } = useParams();


    const fetchCommunity = async (id) => {
        const community = await getCommunityToDisplay(id, 1);
        // console.log("community fetched", community);
        setCurrentCommunity((prev) => community);
    }

    useEffect(() => {
        if(comid) {
            fetchCommunity(comid);
        }
    }, [comid]);


    return (
        <CommunityLayout currentPage={"community"}  currentCommunity={currentCommunity} setCurrentCommunity={setCurrentCommunity}>

            <div className="flex-grow flex flex-col  ">
                <div className="flex flex-col gap-y-2 ">

                    {/* 
                    cbh:40
                    {isLoading &&
                        <>
                            <CommunityAccordionSkeleton></CommunityAccordionSkeleton>
                            <CommunityAccordionSkeleton items={2}></CommunityAccordionSkeleton>
                            <CommunityAccordionSkeleton items={3}></CommunityAccordionSkeleton>
                        </>
                    } */}


                    <div className="flex flex-col gap-y-2 ">
                        {currentCommunity &&
                            <CommunityAccordion
                                currentCommunity={currentCommunity}
                            />
                        }
                    </div>

                </div>
            </div>

        </CommunityLayout>
    );
};

export default Community;

